import { all } from 'redux-saga/effects';
import { handleOnHydrateSearch, handleOnValidateSearch } from '@state/deal-finder/dealFinderOperations';
import { handleOnShouldClear, onSetFilters } from '@state/deal-finder-results/dealFinderResultsOperations';

export function* combinedDealFinderSagas() {
  yield all([handleOnValidateSearch(), handleOnHydrateSearch(), onSetFilters(), handleOnShouldClear()]);
}
